import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { PrivateVideoDto } from '@app/data/dtos/multimedia/video/video.dto';
import { mapPrivateVideo } from '@app/data/mappers/multimedia/video/video.mapper';
import { VideoRepository } from '@app/domain/repositories/multimedia/video/video.repository.contract';
import { PrivateVideo, Video } from '@app/entities/models/multimedia/video.model';
import { LanguageService } from '@app/services/language/language.service';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

import { HttpOptions } from '@/models/http.options.model';

@Injectable({
  providedIn: 'root'
})
export class VideoRepositoryImpl extends MRepository implements VideoRepository {
  readonly url = '/video';

  constructor(private languageService: LanguageService) {
    super(`${ENV.API_URL}`);
  }

  getPrivateVideo(key: string): Observable<PrivateVideo> {
    return this.languageService.getCurrentLanguage().pipe(
      mergeMap((lang: string) => {
        const options = new HttpOptions({ lang });
        return this.get<PrivateVideoDto>(`${this.url}/private/${key}`, options).pipe(map(mapPrivateVideo));
      })
    );
  }

  getPublicVideo(key: string): Observable<Video> {
    return this.get<Video>(`${this.url}/public/${key}`);
  }
}
